<template>
  <v-container
    id="data-tables"
    tag="section"
  >
    <base-v-component
      heading="Операции по договору"
      link="components/data-tables"
    />

    <base-material-card
      color="primary"
      icon="mdi-file-document"
      inline
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Операции по договору
        </div>
      </template>
      <v-data-table
        :headers="headers"
        :items="items"
        :search.sync="search"
        multi-sort
        show-expand
        :footerProps="datatable_footer"
      >
       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
        <template v-slot:top>
          <v-card flat>
            <v-card-text>
              <v-row>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date_create.from"
                    label="Дата создания от"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.date_create.to"
                    label="Дата создания до"
                    type="date"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="form.state"
                    label="Статус"
                    :items="select.state"
                    clearable
                    @keyup.enter="load"
                    @change="load"
                    :disabled="form.part"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="form.part"
                    label="Частичные"
                    @change="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    v-model="form.contract_number"
                    label="Номер договора"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="form.type"
                    label="Тип транзакции"
                    :items="select.type"
                    clearable
                    @keyup.enter="load"
                    @change="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="form.direction"
                    label="Тип операции"
                    :items="select.direction"
                    clearable
                    @keyup.enter="load"
                    @change="load"
                  />
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="form.description"
                    label="Назначение"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.debet"
                    label="Плательщик"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="form.credit"
                    label="Получатель"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.min_sum"
                    label="Сумма от"
                    type="number"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-text-field
                    v-model="form.max_sum"
                    label="Сумма до"
                    type="number"
                    clearable
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="3">
                  <v-checkbox
                    v-model="form.deleted"
                    label="Показывать удаленные"
                    @keyup.enter="load"
                  />
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    @click="load"
                  >
                    Поиск
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    min-width="250"
                    @click="dialog.sverka.show = true"
                  >
                    Сверка
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="secondary"
                    min-width="200"
                    @click="dialog.export.show = true"
                  >
                    Выгрузить в 1C
                  </v-btn>
                </v-col>
                <v-col cols="2">
                  <v-btn
                    color="secondary"
                    dark
                    min-width="250"
                    class="mb-2"
                    @click="clear"
                  >
                    Сбросить фильтры
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:expanded-item="{item, headers }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="4">
                <b>Даты</b>:<br>
                Создание: {{ format(item.date.create) }}<br>
                <span v-if="item.date.process">Исполнение: {{ format(item.date.process) }}<br></span>
                Статус: {{ format(item.state_date) }}
              </v-col>
              <v-col cols="4">
                <span v-if="item.debet">
                  <b>Плательщик</b>:<br>
                  {{ item.debet.name }}<br>
                  ИНН: {{ item.debet.inn }} КПП: {{ item.debet.kpp }}<br>
                  Банк: {{ item.debet.bank_name }} {{ item.debet.bic }}<br>
                  К/с: {{ item.debet.ks }}<br>
                  Р/с: {{ item.debet.rs }}
                </span>
              </v-col>
              <v-col cols="4">
                <span v-if="item.credit">
                  <b>Получатель</b>:<br>
                  {{ item.credit.name }}<br>
                  ИНН: {{ item.credit.inn }} КПП: {{ item.credit.kpp }}<br>
                  Банк: {{ item.credit.bank_name }} {{ item.credit.bic }}<br>
                  К/с: {{ item.credit.ks }}<br>
                  Р/с: {{ item.credit.rs }}
                </span>
              </v-col>
              <v-col cols="12">
                <v-data-table
                  :items="item.payments"
                  :headers="table.payments"
                  :footerProps="datatable_footer"
                />
              </v-col>
            </v-row>
          </td>
        </template>
        <template v-slot:item.sum="{item}">
          <v-chip
            :color="getSumColor(item)"
            dark
          >
            {{ Number(item.sum).money() }}
          </v-chip>
          <v-chip
            color="blue"
            dark
            v-if="item.state == 1 && item.confirm>0"
          >
            {{ item.confirm }}
          </v-chip>
        </template>
        <template v-slot:item.action="{ item }">
          <v-icon
            large
            color="primary"
            class="mr-2"
            @click="sheetitem = item, sheet = true"
          >
            mdi-cog
          </v-icon>
        </template>
        <template v-slot:item.checked="{item}">
          <v-checkbox
            v-model="item.checked"
          />
        </template>
        <template v-slot:item.date="{item}">
          {{ format(item.date.create) }}<br>
        </template>
        <template v-slot:item.type="{item}">
          {{ dict.type[item.type] }}<br>
        </template>
        <template v-slot:item.state="{item}">
          <v-chip
            v-if="item.state!=1"
            :color="getStateColor(item)"
            dark
          >
            {{ dict.state[item.state] }}
          </v-chip>
          <span v-else>{{ dict.state[item.state] }}</span><br>
          <span v-if="item.payments && item.payments.length>0 && item.state == 1">Частичная</span>
        </template>
        <template v-slot:item.contract="{item}">
          <a
            v-if="item.contract_item"
            @click="$router.push('/contract/list?id=' + item.contract_item.id)"
          >{{ item.contract_item.number }}/{{ format_contract_date(item.contract_item.date) }}<br>{{ format(item.contract_item.date) }}</a>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-btn
          color="primary"
          min-width="100"
          @click="dialog.transaction.id = sheetitem.id, dialog.transaction.create = true, dialog.transaction.view = false, sheet = false, dialog.transaction.show = true"
        >
          Создать
        </v-btn>
        <v-btn
          color="primary"
          min-width="300"
          @click="dialog.state.item = { ids: items.filter(a=>a.checked).map(a=>a.id), state: 1}, sheet = false, dialog.state.show = true, dialog.state.item.multiple = true"
        >
          Сменить статус выбранным
        </v-btn>
      </v-card-actions>
    </base-material-card>
    <v-dialog
      v-model="dialog.state.show"
      persistent
      scrollable
      max-width="50%"
    >
      <v-card class="elevation-1">
        <v-card-title class="headline">
          Изменение статуса
        </v-card-title>
        <v-card-text>
          <v-select
            v-model="dialog.state.item.state"
            :items="select.state"
          />
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-btn
            color="primary"
            flat
            @click="dialog.state.show = false"
          >
            Назад
          </v-btn>
          <v-spacer />
          <v-btn
            color="red"
            flat
            @click="changeState"
          >
            Сохранить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog.sverka.show"
      persistent
      scrollable
      max-width="90%"
    >
      <v-card class="elevation-1">
        <v-card-title class="headline">
          Сверка
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="4">
              Период сверки транзакций
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="sverka.transaction.from"
                label="Дата"
                type="date"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="sverka.transaction.to"
                label="Дата"
                type="date"
              />
            </v-col>
            <v-col cols="4">
              Период сверки операций
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="sverka.operation.from"
                label="Дата"
                type="date"
              />
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="sverka.operation.to"
                label="Дата"
                type="date"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <v-select
                v-model="sverka.type"
                :items="select.sverka"
                label="Тип сверки"
              />
            </v-col>
            <v-col cols="6">
              Найдено соответствий: {{ sverka.data.operations.filter(a=>a.transaction).length }}<br>
              Количество необработанных транзакций: {{ sverka.data.transactions.filter(a=>a.payments.length == 0).length }}<br>
              Количество необработанных операций: {{ sverka.data.operations.filter(a=>!a.transaction).length }}
            </v-col>
          </v-row>
          <v-row>
            <v-data-table
              :headers="headers_short"
              :items="sverka.data.transactions.filter(a=>a.payments.length>0)"
              show-expand
              :footerProps="datatable_footer"
            >
             <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
        {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
        </template>
              <template v-slot:item.action="{item}">
                <v-icon @click="sverka.data.transactions = sverka.data.transactions.filter(a=>a!=item)">
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:expanded-item="{item, headers }">
                <td :colspan="headers.length">
                  <v-row>
                    <v-col cols="4">
                      <b>Даты</b>:<br>
                      Создание: {{ format(item.date.create) }}<br>
                      <span v-if="item.date.process">Исполнение: {{ format(item.date.process) }}<br></span>
                      Статус: {{ format(item.state_date) }}
                    </v-col>
                    <v-col cols="4">
                      <span v-if="item.debet">
                        <b>Плательщик</b>:<br>
                        {{ item.debet.name }}<br>
                        ИНН: {{ item.debet.inn }} КПП: {{ item.debet.kpp }}<br>
                        Банк: {{ item.debet.bank_name }} {{ item.debet.bic }}<br>
                        К/с: {{ item.debet.ks }}<br>
                        Р/с: {{ item.debet.rs }}
                      </span>
                    </v-col>
                    <v-col cols="4">
                      <span v-if="item.credit">
                        <b>Получатель</b>:<br>
                        {{ item.credit.name }}<br>
                        ИНН: {{ item.credit.inn }} КПП: {{ item.credit.kpp }}<br>
                        Банк: {{ item.credit.bank_name }} {{ item.credit.bic }}<br>
                        К/с: {{ item.credit.ks }}<br>
                        Р/с: {{ item.credit.rs }}
                      </span>
                    </v-col>
                    <v-col cols="12">
                      <v-data-table
                        :items="item.payments"
                        :headers="table.payments"
                        :footerProps="datatable_footer"
                      >
                       <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
          {{ pageStart }}-{{ pageStop }} из {{itemsLength}}
          </template>
                        <!--<template v-slot:item.action="{item}">
                  <v-icon @click="item.payments = item.payments.filter(a=>a!=item)">mdi-delete</v-icon>
                </template>-->
                      </v-data-table>
                    </v-col>
                  </v-row>
                </td>
              </template>
              <template v-slot:item.sum="{item}">
                <v-chip
                  :color="getSumColor(item)"
                  dark
                >
                  {{ item.sum }}                 
                </v-chip>
                 <v-chip
                  color="blue"
                  dark
                  v-if="item.sum!=item.fact"
                >
                  {{ item.fact }}                 
                </v-chip>
              </template>
              <template v-slot:item.date="{item}">
                {{ format(item.date.create) }}<br>
              </template>
              <template v-slot:item.type="{item}">
                {{ dict.type[item.type] }}<br>
              </template>
              <template v-slot:item.state="{item}">
                <v-chip
                  v-if="item.state!=1"
                  :color="getStateColor(item)"
                  dark
                >
                  {{ dict.state[item.state] }}
                </v-chip>
                <span v-else>{{ dict.state[item.state] }}</span>
              </template>
              <template v-slot:item.contract="{item}">
                <a
                  target="_blank"
                  :href="'/contract/list?id=' + item.contract_item.id"
                >№{{ item.contract_item.number }}/{{ format_contract_date(item.contract_item.date) }}<br>{{ format(item.contract_item.date) }}</a>
              </template>
            </v-data-table>
          </v-row>
        </v-card-text>
        <v-card-actions class="grey lighten-4">
          <v-col cols="4">
            <v-btn
              min-width="200"
              color="secondary"
              @click="dialog.sverka.show = false"
            >
              Назад
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              min-width="200"
              color="primary"
              :disabled="loader.show"
              @click="sverka_run(false)"
            >
              Поехали
            </v-btn>
          </v-col>
          <v-col cols="4">
            <v-btn
              min-width="200"
              color="success"
              :disabled="loader.show"
              @click="sverka_run(true)"
            >
              Выполнить привязку
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-list>
        <v-list-group v-model="sheetmenu">
          <v-list-item slot="activator">
            <v-list-item-action>
              <v-icon>mdi-build</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Действия</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="dialog.transaction.id = sheetitem.id, dialog.transaction.create = false, dialog.transaction.view = false, dialog.transaction.change = true,sheet = false, dialog.transaction.show = true">
            <v-list-item-content>
              Редактировать
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="dialog.transaction.id = sheetitem.id, dialog.transaction.create = false, dialog.transaction.view = true, dialog.transaction.change = true,sheet = false, dialog.transaction.show = true">
            <v-list-item-content>
              Просмотр
            </v-list-item-content>
          </v-list-item>
          <v-list-item @click="dialog.state.item = { id: sheetitem.id, state: sheetitem.state || 1}, sheet = false, dialog.state.show = true, dialog.state.item.multiple = false">
            <v-list-item-content>
              Изменить статус
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-bottom-sheet>
    <v-dialog
      v-model="dialog.transaction.show"
      persistent
    >
      <transaction-form
        :create="dialog.transaction.create"
        :id="dialog.transaction.id"
        :view="dialog.transaction.view"
        :change="dialog.transaction.change"
        :show="dialog.transaction.show"
        @create="create_transaction"
        @close="dialog.transaction.show = false, load()"
      />
    </v-dialog>
    <v-dialog
      v-model="dialog.export.show"
      max-width="700"
      persistent
    >
      <v-card>
        <v-card-title>Выгрузка транзакций</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="dialog.export.number"
                type="number"
                label="Начинать нумерация с"
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="dialog.export.date"
                type="date"
                label="Дата выгрузки"
              />
            </v-col>
            <v-col cols="12">
              <v-btn
                color="primary"
                min-width="200"
                @click="export_transactions"
              >
                Выгрузить
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import TransactionForm from './components/Transaction-form.vue'
  import moment from 'moment'
  import $ from 'jquery'
  export default {
    name: 'DashboardDataTables',
    components: { TransactionForm },
    data: () => ({
      datatable_footer: {
        itemsPerPageAllText: 'Все',
        itemsPerPageText: 'Показывать по', pageText: 'из'
      },
      loader: {
        show: false,
      },
      sverka: {
        transaction: {},
        operation: {},
        type: 3,
        data: {
          operations: [],
          transactions: [],
        },
      },
      dialog: {
        transaction: {
          show: false,
          create: false,
          view: false,
          id: '',
        },
        sverka: {
          show: false,
        },
        state: {
          item: {},
          show: false,
        },
        export: {
          show: false,
        },
      },
      sheet: false,
      sheetmenu: true,
      sheetitem: {
        docs: [],
      },
      table: {
        payments: [
          { text: 'Дата', value: 'date' },
          { text: 'Плательщик', value: 'payer.name' },
          { text: 'Получатель', value: 'recipient.name' },
          { text: 'Описание', value: 'description' },
          { text: 'Сумма', value: 'sum', width: 150 },
          { text: '', value: 'action' },
        ],
      },
      headers: [
        {
          sortable: false,
          text: '',
          value: 'action',
        },
        {
          text: '',
          value: 'checked',
        },
        {
          text: 'Дата',
          value: 'date',
          width: 110,
        },
        {
          text: 'Статус',
          value: 'state',
          width: 200,
        },
        {
          text: 'Договор',
          value: 'contract',
          width: 120,
        },
        {
          text: 'Тип',
          value: 'type',
        },
        {
          text: 'Сумма',
          value: 'sum',
          width: 150,
        },
        {
          text: 'Назначение',
          value: 'description',
          width: 250,
        },
        {
          text: 'Плательщик',
          value: 'debet.name',
        },
        {
          text: 'Получатель',
          value: 'credit.name',
        },
      ],
      headers_short: [
        {
          text: 'Дата',
          value: 'date',
        },
        {
          text: 'Статус',
          value: 'state',
        },
        {
          text: 'Договор',
          value: 'contract',
        },
        {
          text: 'Тип транзакции',
          value: 'type',
        },
        {
          text: 'Сумма',
          value: 'sum',
        },
        {
          text: 'Назначение',
          value: 'description',
        },
        {
          text: 'Наименование плательщика',
          value: 'debet.name',
        },
        {
          text: 'Наименование получателя',
          value: 'credit.name',
        },
        { text: '', value: 'action' },
      ],
      items: [],
      search: undefined,
      form: {
        date_create: {
          from: '',
          to: '',
        },
        date_process: {
          from: '',
          to: '',
        },
        state: 0,
        deleted: false,
      },
      select: {
        state: [
          { value: 1, text: 'Новая' },
          { value: 2, text: 'Исполнена' },
          { value: 3, text: 'Удалена по расторжению договора' },
          { value: 8, text: 'Удалена' },
        ],
        direction: [
          { value: 1, text: 'Приход' },
          { value: 2, text: 'Расход' },
        ],
        type: [],
        contract: [],
        sverka: [
          
          { value: 3, text: 'Номер страхового полиса' },
          { value: 4, text: 'Гос. номер автомобиля' },
          { value: 5, text: 'Номер страхового дела' },
          { value: 6, text: 'Номер договора' },
          { value: 7, text: 'VIN номер' },
          
        ],
      },
      dict: {
        state: {
          1: 'Новая',
          2: 'Исполнена',
          3: 'Удалена по расторжению договора',
          8: 'Удалена',
        },
        direction: {
          1: 'Приход',
          2: 'Расход',
        },
        type: {},
        type_reverse: {},
      },
    }),
    mounted: function () {
      this.dialog.export.date = moment().format('YYYY-MM-DD')
      this.dialog.export.number = 1
      this.form.date_create.from = moment().format('YYYY-MM-DD')
      this.form.date_create.to = moment().format('YYYY-MM-DD')
      this.sverka.transaction.from = moment().add(-1, 'months').format('YYYY-MM-DD')
      this.sverka.transaction.to = moment().format('YYYY-MM-DD')
      this.sverka.operation.from = moment().add(-1, 'months').format('YYYY-MM-DD')
      this.sverka.operation.to = moment().format('YYYY-MM-DD')
      let store_filters = JSON.parse(localStorage.getItem('transaction_filters') ? localStorage.getItem('transaction_filters') : '{}')
      if (store_filters) {
        if (store_filters.date_create) {
          if (store_filters.date_create.from) {
            this.form.date_create.from = store_filters.date_create.from
          }
          if (store_filters.date_create.to) {
            this.form.date_create.to = store_filters.date_create.to
          }
        }
        if (store_filters.state) {
          this.form.state = store_filters.state
        }
        if (store_filters.contract_number) {
          this.form.contract_number = store_filters.contract_number
        }
        if (store_filters.type) {
          this.form.type = store_filters.type
        }
        if (store_filters.direction) {
          this.form.direction = store_filters.direction
        }
        if (store_filters.description) {
          this.form.description = store_filters.description
        }
        if (store_filters.credit) {
          this.form.credit = store_filters.credit
        }
        if (store_filters.deleted) {
          this.form.deleted = store_filters.deleted
        }
      }
      if (this.$route.query.contract) {
        this.form.contract_number = this.$route.query.contract
        this.form.date_create.from = moment().add(-365, 'days').format('YYYY-MM-DD')
        this.form.date_create.to = moment().format('YYYY-MM-DD')
      }
      if (this.$route.query.id) {
        this.form = {
            date_create: {
            from: '',
            to: '',
          },
          date_process: {
            from: '',
            to: '',
          },
          state: 0,
          deleted: false,
        }
        this.form.id = this.$route.query.id
      }
      this.load()
      for (let x in this.$store.state.dict.transaction_type) {
        this.select.type.push({ value: Number(x), text: this.$store.state.dict.transaction_type[x].name, direction: Number(this.$store.state.dict.transaction_type[x].direction), key: this.$store.state.dict.transaction_type[x].key })
        this.dict.type[x] = this.$store.state.dict.transaction_type[x].name
        this.dict.type_reverse[this.$store.state.dict.transaction_type[x].key] = x
      }
    },
    methods: {
      clear: function () {
        this.form = {
          date_create: {
            from: '',
            to: '',
          },
          date_process: {
            from: '',
            to: '',
          },
          state: 0,
          deleted: false,
        }
        this.form.date_create.from = moment().format('YYYY-MM-DD')
        this.form.date_create.to = moment().format('YYYY-MM-DD')
      },
      export_transactions: function () {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/transaction/export',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: JSON.stringify(this.form),
            name: 'form',
          })
        )
        form.append(
          $('<input>', {
            type: 'hidden',
            value: this.dialog.export.date,
            name: 'date',
          })
        )
        if (this.items.filter(a => a.checked).length > 0) {
          form.append(
            $('<input>', {
              type: 'hidden',
              value: JSON.stringify(this.items.filter(a => a.checked)),
              name: 'items',
            })
          )
        }
        form.append(
          $('<input>', {
            type: 'hidden',
            value: this.dialog.export.number,
            name: 'number',
          })
        )
        form.appendTo('body').submit()
      },
      sverka_run: function (finish) {
        this.loader.show = true
        if (!finish) {
          this.axios.post('/api/transaction/sverka/find', this.sverka)
            .then(result => {
              if (!result.data.error) {
                this.sverka.data = result.data.data
                for (let x in this.sverka.transaction) 
                {
                  this.sverka.transaction[x].fact = 0
                  if (this.sverka.transaction[x].payments) {
                    for (let y in this.sverka.transaction[x].payments) {
                      this.sverka.transaction[x].fact += this.sverka.transaction[x].payments[y].sum
                    }
                  }
                }
              }
              this.loader.show = false
            })
            .catch(e => {
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
              this.loader.show = false
            })
        } else {
          this.axios.post('/api/transaction/sverka/finish', this.sverka)
            .then(result => {
              this.loader.show = false
              if (!result.data.error) {
                this.sverka.data.operations = []
                this.sverka.data.transactions = []
                //this.dialog.sverka.show = false
                //this.load()
              }
            })
            .catch(e => {
              this.loader.show = false
              this.$store.commit('snackbar', 'Ошибка при обновлении данных')
            })
        }
      },
      getSumColor: function (item) {
        if (item.direction == 1) return 'green'
        return 'red'
      },
      getStateColor: function (item) {
        if (item.state == 3) return 'red'
        else return 'green'
      },
      format: function (date) {
        return moment(date).format('DD.MM.YYYY')
      },
      format_contract_date: function (date) {
        return moment(date).format('DDMM')
      },
      create_transaction: function (data) {
        this.axios.post('/api/transaction/create', data)
          .then(result => {
            if (!result.data.error) {
              this.dialog.transaction.show = false
              this.load()
            }
          })
          .catch(e => {
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      changeState: function () {
        this.axios.post('/api/transaction/state', this.dialog.state.item)
          .then(result => {
            if (!result.data.error) {
              this.dialog.state.show = false
              this.load()
            }
          })
          .catch(e => {
            this.dialog.state.show = false
            this.$store.commit('snackbar', 'Ошибка при обновлении данных')
          })
      },
      getDoc: function (item) {
        let form = $('<form>', {
          target: '_blank',
          action: '/api/common/document',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      load: function () {
        localStorage.setItem('transaction_filters', JSON.stringify(this.form))
        this.axios.post('/api/transaction/list', this.form)
          .then(result => {
            if (!result.data.error) {
              this.items = result.data.data
              for (let x in this.items) {
                this.items[x].confirm = 0
                if (this.items[x].payments) {
                  for (let y in this.items[x].payments) {
                    this.items[x].confirm+= Number(this.items[x].payments[y].sum)
                  }
                }
              }
              if (this.form.id) {
                this.form.id = null
                /*if (this.items[0] && this.items[0].contract_item) {
                  this.clear()
                  this.form.contract_number = this.items[0].contract_item.number + '/' + this.format_contract_date(this.items[0].contract_item.date)
                  this.form.date_create.from = moment(this.items[0].contract_item.date).format('YYYY-MM-DD')
                  this.form.date_create.to = moment().format('YYYY-MM-DD')
                  
                  this.load()
                }*/
              }
            }
          })
          .catch(e => {
            console.log(e)
            this.$store.commit('snackbar', 'Ошибка при получении данных')
          })
      },
    },
  }
</script>
